<template>
  <v-card color="grey lighten-4" min-width="500px" max-width="800px" flat>
    <v-toolbar :color="selectedEvent.color || 'primary'" dark>
      <v-toolbar-title>
        {{ selectedEvent.startTime | formatTime }} -
        {{ selectedEvent.endTime | formatTime }}
        <span
          class="ml-1"
          v-if="selectedEvent.presentationType"
          v-html="$t(`presentationType.${selectedEvent.presentationType}`)"
        />
      </v-toolbar-title>
    </v-toolbar>
    <v-card-title>
      <v-row justify="space-between" align="center">
        <v-col cols="auto">
          <p>
            <span class="text-h4 text--primary" style="word-break: break-word">
              {{
                selectedEvent[
                  "title" + (eventLocale === "de" ? "" : `_${eventLocale}`)
                ]
              }}
            </span>
          </p>
        </v-col>
        <v-col
          cols="2"
          v-if="selectedEvent.abstractPdf || selectedEvent.paperPdf"
        >
          <v-menu bottom left offset-y>
            <template v-slot:activator="{ on }">
              <v-btn icon v-on="on">
                <v-icon>mdi-download</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                v-if="selectedEvent.abstractPdf"
                :href="selectedEvent.abstractPdf._url"
                target="_blank"
              >
                <v-list-item-title>Abstract</v-list-item-title>
              </v-list-item>
              <v-list-item
                v-if="selectedEvent.paperPdf"
                :href="selectedEvent.paperPdf._url"
                target="_blank"
              >
                <v-list-item-title>Paper</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu></v-col
        >
      </v-row>
    </v-card-title>
    <v-card-subtitle v-if="selectedEvent.room" class="pb-0">
      <v-icon small>mdi-map-marker</v-icon>
      {{ $t(`room.${selectedEvent.room}`) }}
    </v-card-subtitle>
    <v-card-text>
      <template v-if="selectedEvent.events">
        <div :key="event.id" class="py-2" v-for="event of selectedEvent.events">
          <v-divider class="pb-1" />
          <v-row justify="space-between" align="center">
            <v-col cols="auto">
              <p>
                <span
                  class="text-h4 text--primary"
                  style="word-break: break-word"
                >
                  {{
                    event[
                      "title" + (eventLocale === "de" ? "" : `_${eventLocale}`)
                    ]
                  }}
                </span>

                <span class="text-h6 text--primary">
                  ({{ event.startTime | formatTime }} -
                  {{ event.endTime | formatTime }})
                </span>
              </p>
            </v-col>
            <v-col cols="2" v-if="event.abstractPdf || event.paperPdf">
              <v-menu bottom left offset-y>
                <template v-slot:activator="{ on }">
                  <v-btn icon v-on="on">
                    <v-icon>mdi-download</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item
                    v-if="event.abstractPdf"
                    :href="event.abstractPdf._url"
                    target="_blank"
                  >
                    <v-list-item-title>Abstract</v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    v-if="event.paperPdf"
                    :href="event.paperPdf._url"
                    target="_blank"
                  >
                    <v-list-item-title>Paper</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-col>
          </v-row>
          <p
            class="body-1 text--primary"
            v-if="event['abstract_' + eventLocale]"
            v-html="event['abstract_' + eventLocale]"
          ></p>
          <v-card v-if="event.authors && event.authors.length" class="pa-4">
            <v-row dense v-for="(item, i) in event.authors" :key="i">
              <v-col>
                {{ item.author }}
                <v-btn
                  v-if="item.cv"
                  class="ml-1"
                  outlined
                  small
                  primary
                  @click="
                    $set(event.authors, i, {
                      ...item,
                      showCV: item.showCV ? false : true,
                    })
                  "
                >
                  <v-icon small left v-if="!item.showCV">mdi-eye</v-icon>
                  <v-icon small left v-else>mdi-eye-off</v-icon>
                  CV
                </v-btn>
              </v-col>
              <v-col v-if="item.companyUrl" class="text-wrap">
                <a :href="item.companyUrl" target="_blank">{{
                  item.company
                }}</a>
              </v-col>
              <v-col v-else>
                {{ item.company }}
              </v-col>
              <v-card v-if="item.showCV" class="my-2 pa-4" outlined>
                {{ item.cv }}
              </v-card>
            </v-row>
          </v-card>
        </div>
      </template>
      <template v-else>
        <p
          class="body-1 text--primary mt-4"
          v-if="selectedEvent['abstract_' + eventLocale]"
          v-html="selectedEvent['abstract_' + eventLocale]"
        ></p>
        <v-card
          v-if="selectedEvent.authors && selectedEvent.authors.length"
          class="pa-4"
        >
          <v-row dense v-for="(item, i) in selectedEvent.authors" :key="i">
            <v-col>
              {{ item.author }}
              <v-btn
                v-if="item.cv"
                class="ml-1"
                outlined
                small
                primary
                @click="
                  $set(selectedEvent.authors, i, {
                    ...item,
                    showCV: item.showCV ? false : true,
                  })
                "
              >
                <v-icon small left v-if="!item.showCV">mdi-eye</v-icon>
                <v-icon small left v-else>mdi-eye-off</v-icon>
                CV
              </v-btn>
            </v-col>
            <v-col v-if="item.companyUrl" class="text-wrap">
              <a :href="item.companyUrl" target="_blank">{{ item.company }}</a>
            </v-col>
            <v-col v-else>
              {{ item.company }}
            </v-col>
            <v-card v-if="item.showCV" class="my-2 pa-4" outlined>
              {{ item.cv }}
            </v-card>
          </v-row>
        </v-card>
      </template>
    </v-card-text>
    <v-card-actions>
      <v-btn
        :color="selectedEvent.color || 'primary'"
        dark
        @click="$emit('close')"
      >
        {{ $t("close") }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { i18n } from "../plugins/i18n";

export default {
  props: ["selectedEvent"],
  computed: {
    eventLocale() {
      return i18n.locale;
    },
  },
};
</script>

<style></style>
